/** Firebase codes that mean the session itself is gone, so a forced token refresh can never succeed. */
const CREDENTIAL_CODES = new Set(['auth/user-token-expired', 'auth/user-disabled', 'auth/invalid-user-token', 'auth/user-not-found']);

export const NO_FIREBASE_USER = 'No Firebase user signed in';

/** Why the 401 retry's token refresh failed: the credential is gone ('unauthorized'), or anything else ('network', retryable). */
export function refreshFailureKind(err: unknown): 'unauthorized' | 'network' {
  if (err instanceof Error && err.message === NO_FIREBASE_USER) return 'unauthorized';
  const code = typeof err === 'object' && err !== null ? (err as { code?: unknown }).code : undefined;
  return typeof code === 'string' && CREDENTIAL_CODES.has(code) ? 'unauthorized' : 'network';
}
